export class Asset {
    assetId: number;
    path: string;
    notes: string = '';
    timestamp: string;

    constructor(asset?: Partial<Asset>) {
        Object.assign(this, asset);
    }
}